/**************************************************
 * Nombre:       Seccion_Despachos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {
    CASILLA_ESTADO,
    CASILLA_FECHA_DATO, CASILLA_MONEDA,
    CASILLA_TEXTO
} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import {useObtenerColleccionTabla2025} from "../../Servicios/BD/useObtenerColleccionTabla2025";
import React from "react";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import {ManageSearch,TextSnippet,AddAPhoto} from "@mui/icons-material";
import {ESTADOSUSUARIOS} from "../../Constantes";
import Dialogo_Varietal from "../Dialogos/Varietales/Dialogo_Varietal";
import Dialogo_Varietal_Descripcion from "../Dialogos/Varietales/Dialogo_Varietal_Descripcion";
import Dialogo_Varietal_Fotos from "../Dialogos/Varietales/Dialogo_Varietal_Fotos";


const Seccion_Varietales = () => {
    const {props, setData, setNumeroFilas, cargarNuevamente} = useObtenerColleccionTabla2025({coleccion: 'varietales'})
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Varietal,
        titulo: 'Detalles de varietal',
        realizado: cargarNuevamente
    })
    const {Dialogo:DialogoDescripcion, abrir:abrirDescripcion} = useDialogo({
        Componente: Dialogo_Varietal_Descripcion,
        titulo: 'Descripciones de varietal',
        realizado: cargarNuevamente
    })
    const {Dialogo:DialogoFotos, abrir:abrirFotos} = useDialogo({
        Componente: Dialogo_Varietal_Fotos,
        titulo: 'Descripciones de varietal',
        realizado: cargarNuevamente
    })

    const click = (id, data) => {
        console.log(data)
        switch (id) {
            case 'detalles':
                abrir(data)
                break
            case 'descripcion':
                abrirDescripcion(data)
                break
            case 'fotos':
                abrirFotos(data)
                break
            default :
                abrir(data)
        }
    }


    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px'}}
                spacing={3}
            >

                <Dialogo/>

                <DialogoDescripcion/>

                <DialogoFotos/>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Tabla_Filtro
                        nombre={'Lista productos en menu'}
                        descripcion={`${props.numeroFilas} en base de datos`}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                        clickAgregar={abrir}
                        botonesData={botonesData}
                        clickData={click}
                        // funcionBuscar={funcionBuscar}
                        //  botones={[]}
                    />
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Seccion_Varietales

const filtros = [
    {
        nombre: 'Nombre',
        direccion: 'asc',
        propiedad: 'nombre'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    },
]

const datosCabecera = [
    {
        nombre: 'Nombre',
        direccion: 'left',
        propiedad: 'nombre',
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATO
    },
    {
        nombre: 'Categoria',
        direccion: 'left',
        propiedad: 'categoria',
        tipo: CASILLA_TEXTO

    },
    {
        nombre: 'Region',
        direccion: 'left',
        propiedad: 'region',
        tipo: CASILLA_TEXTO

    },
    {
        nombre: 'Origen',
        direccion: 'left',
        propiedad: 'origen',
        tipo: CASILLA_TEXTO
    },
    {
        nombre: 'Estado',
        direccion: 'right',
        propiedad: 'estado',
        tipo: CASILLA_ESTADO,
        estados: ESTADOSUSUARIOS
    },

]

const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    },{
        nombre: 'Descripcion',
        id: 'descripcion',
        icono: TextSnippet
    },
    {
        nombre: 'Fotos',
        id: 'fotos',
        icono: AddAPhoto
    },
]